import React from 'react'
import testi1 from '../images/rona-after.jpeg'
import testi2 from '../images/test2.jpg'
import testi3 from '../images/test3.jpg'
import testi4 from '../images/test4.jpg'
import testi5 from '../images/test5.jpg'
import testi6 from '../images/test6.jpg'
import quotes from '../images/icons8-quote-100.png'
import star from '../images/icons8-star-30.png'
import trans1B from '../images/transformations/bf1before.png'
import trans1A from '../images/transformations/bf1after.png'
import trans2B from '../images/transformations/bf2before.png'
import trans2A from '../images/transformations/bf2after.png'
import trans3B from '../images/transformations/bf3before.png'
import trans3A from '../images/transformations/bf3after.png'
import trans4B from '../images/transformations/bf4before.png'
import trans4A from '../images/transformations/bf4after.png'
import trans5B from '../images/transformations/bf5before.png'
import trans5A from '../images/transformations/bf5after.png'
import trans6B from '../images/transformations/bf6before.png'
import trans6A from '../images/transformations/bf6after.png'
import review1 from '../images/reviews/review1.jpg'
import review2 from '../images/reviews/review2.jpg'
import review3 from '../images/reviews/review3.jpg'
import review4 from '../images/reviews/review4.jpg'
import review5 from '../images/reviews/review5.jpg'
import review6 from '../images/reviews/review6.jpg'


import {TfiArrowCircleLeft, TfiArrowCircleRight} from 'react-icons/tfi'
import {ReactCompareSlider, ReactCompareSliderImage} from 'react-compare-slider'
import {Link} from 'react-router-dom'
import {trans} from "../utils";

const Home = () => {

    const reviews = [
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'Reliable, courteous, professional and responsible Type of treatment: dental implants | Dental implant in one day',
            name: '- Shuli Hassan.',
            image: testi3,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'Amin I will work from the heart and thank you for the wonderful result. I hope for success in the future',
            name: '- A. .',
            image: testi2,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'I arrived at the Perfect Smile clinic, they received me very nicely, they took panoramic and city photos and I immediately knew that this is the only place I can do type of treatment: dental implants | Dental implant in one day',
            name: '- Sion',
            image: testi4,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'Dedicated care, great attitude and patience, and reasonable prices. Thank you very much. All the best. Type of treatment: dental implant',
            name: '- Sigal Geva.',
            image: testi5,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'Sensitive professional dentist and very reasonable prices and excellent service Type of treatment: dental implants',
            name: '- Yigal Cohen.',
            image: testi1,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'A pleasant experience. Very good treatment and humane treatment at a high and professional level. Type of treatment: surgical extractions',
            name: '- Anan.',
            image: testi6,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'A reliable, professional, and responsible dentist. Type of treatment: Dental implants | Same-day dental implants.',
            name: 'Shuli Hassan',
            image: review1,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'They work from the heart, and thank you for the wonderful result.I hope for success in the future.',
            name: 'A.',
            image: review2,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'I came to Perfect Smile clinic.They received me very nicely.They did panoramic and CT scans, and I immediately knew that I would get my treatment done here.Type of treatment: Dental implants | Same-day dental implants.',
            name: 'Sivan',
            image: review3,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'Dedicated treatment with excellent care and patience, and reasonable prices. Thank you very much, well done 🙏 Type of treatment: Dental implants.',
            name: 'Sigal Geva',
            image: review4,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'A professional and sensitive dentist with very reasonable prices and excellent service. Type of treatment: Dental implants.',
            name: 'Yigal Cohen',
            image: review5,
        },
        {
            heading: 'Recommendations',
            subHeading: 'Our patient reviews',
            stars: 5,
            description: 'A pleasant experience, very good treatment, and humane and professional service. Type of treatment: Surgical extractions.',
            name: 'Anan',
            image: review6,
        },
    ];

    return (
        <div id='homePage'>
            <header className='d-flex max-sm:flex-col-reverse'>
                <div id='leftSideHeader'
                     style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}
                     className='max-sm:h-auto p-4 max-sm:w-auto'>
                    <h6 className="mb-5 text-2xl">{trans('Welcome in Perfect Smile')}</h6>
                    <h1 className="mb-0 text-white">{trans('Turn Your Smile Into An Example')}</h1>
                    <p className='text-white fw-bold mt-8 text-2xl' style={{width: '80%'}}>{trans('Today, jaws with missing or damaged teeth can be restored using specialized implants. During the treatment, implants are placed and a temporary bridge is fitted.')}</p>
                    <Link to="/appointment#appointFormSec">
                        <button>{trans('Schedule Appointment')}</button>
                    </Link>
                </div>
                <div id='rightSideHeader' className='col-5 max-sm:w-auto max-sm:h-[500px]'>

                </div>
            </header>


            <section id='serviceSec'>
                <h1 className='text-center h1 theme-blue-color mb-24 pt-32 lg: max-lg:pt-12 max-lg:mb-12'>{trans('Our Services')}</h1>
                <div className='container xl:min-w-[1450px] pb-36 max-md:pb-12'>
                    <div id='treatments' className='grid  lg:grid-cols-2 xl:grid-cols-3  gap-5 grid-cols-1'>
                        <Link to="/service-mouth-dental">
                            <div className='service   service1  duration-300'>
                                <div className='relative mainTextDiv'>
                                    <h6 className='text-white text-center h1 mt-3 mb-6'>{trans('Dental Implants')}</h6>
                                    <div className='text-white text-center textDiv '>
                                        <h6 className='h4 mb-4'>{trans('Treatment Description')}</h6>
                                        <p className='text-center h-36 px-14 mt-2 text-lg'>{trans('1. Final restoration implantation within two days. 2. Solutions for difficult cases due to complex bone problems, possibility of restoration of zirconia crowns on implants.')}</p>
                                        {/*<button*/}
                                        {/*    className='mt-4  py-2 mb-4 font-semibold text-[#656B6F] relative hover:text-[#336cd7] duration-300'>{trans('Read More')}</button>*/}
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/service-basal-graft">
                            <div className='service   service2  duration-300'>
                                <div className='relative mainTextDiv'>
                                    <h6 className='text-white text-center h1 mt-3 mb-6'>{trans('Zirconia Crowns')}</h6>
                                    <div className='text-white text-center textDiv '>
                                        <h6 className='h4 mb-4'>{trans('Treatment Description')}</h6>
                                        <p className='text-center h-36 px-14 mt-2 text-lg'>{trans('Wearing full zirconia crowns with diamond coating, designed by computer in the shape of the complete and beautiful tooth on the damaged tooth.')}</p>
                                        {/*<button*/}
                                        {/*    className='mt-4  py-2 mb-4 font-semibold text-[#656B6F] relative hover:text-[#336cd7] duration-300'>{trans('Read More')}</button>*/}
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/service-zirconia-crowns">
                            <div className='service   service3  duration-300'>
                                <div className='relative mainTextDiv'>
                                    <h6 className='text-white text-center h1 xl:mt-3 mb-6 max-xl:mt-8'>{trans('Digital Measurements')}</h6>
                                    <div className='text-white text-center textDiv '>
                                        <h6 className='h4 mb-4'>{trans('Treatment Description')}</h6>
                                        <p className='text-center h-36 px-14 mt-2 text-lg'>{trans('Intraoral scanner is a new and advanced technology in the world that basically scans the teeth and generates a three-dimensional image.')}</p>
                                        {/*<button*/}
                                        {/*    className='mt-4  py-2 mb-4 font-semibold text-[#656B6F] relative hover:text-[#336cd7] duration-300'>{trans('Read More')}</button>*/}
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <Link to="/service-ct-scan">
                            <div className='service   service4  duration-300'>
                                <div className='relative mainTextDiv'>
                                    <h6 className='text-white text-center h1 xl:mt-3 mb-6 max-xl:mt-8'>{trans('Digital Measurements')}</h6>
                                    <div className='text-white text-center textDiv '>
                                        <h6 className='h4 mb-4'>{trans('Treatment Description')}</h6>
                                        <p className='text-center h-36 px-14 mt-2 text-lg'>{trans('Intraoral scanner is a new and advanced technology in the world that basically scans the teeth and generates a three-dimensional image.')}</p>
                                        {/*<button*/}
                                        {/*    className='mt-4  py-2 mb-4 font-semibold text-[#656B6F] relative hover:text-[#336cd7] duration-300'>{trans('Read More')}</button>*/}
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <Link to="/service-transparent-orthodontics">
                            <div className='service   service5  duration-300'>
                                <div className='relative mainTextDiv'>
                                    <h6 className='text-white text-center h1 mt-3 mb-6'>{trans('Invisible Teeth Alignment')}</h6>
                                    <div className='text-white text-center textDiv '>
                                        <h6 className='h4 mb-4'>{trans('Treatment Description')}</h6>
                                        <p className='text-center h-36 px-14 mt-2 text-lg'>{trans('A innovative method for teeth alignment using transparent, invisible trays that allow patients to undergo aesthetic teeth alignment.')}</p>
                                        {/*<button*/}
                                        {/*    className='mt-4  py-2 mb-4 font-semibold text-[#656B6F] relative hover:text-[#336cd7] duration-300'>{trans('Read More')}</button>*/}
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <Link to="/service-panorama-photography">
                            <div className='service   service6  duration-300'>
                                <div className='relative mainTextDiv'>
                                    <h6 className='text-white text-center h1 mt-3 mb-6'>{trans('Panorama Photography')}</h6>
                                    <div className='text-white text-center textDiv '>
                                        <h6 className='h4 mb-4'>{trans('Treatment Description')}</h6>
                                        <p className='text-center h-36 px-14 mt-2 text-lg'>{trans('At our clinic, panoramic and CT scans can be done.')}</p>
                                        {/*<button*/}
                                        {/*    className='mt-4  py-2 mb-4 font-semibold text-[#656B6F] relative hover:text-[#336cd7] duration-300'>{trans('Read More')}</button>*/}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </section>

            <section id="testimonSec" className=' bg-[#f3f3f3]'>

                <div className=' '>
                    <div id="carouselExampleDark" className="carousel carousel-dark slide carousel-fade"
                         data-bs-ride="carousel">
                        <div className="carousel-indicators z-0">
                            {
                                reviews.map((_, index) => (
                                    <button
                                        type="button"
                                        data-bs-target="#carouselExampleIndicators"
                                        data-bs-slide-to={index}
                                        className={index === 0 ? 'active' : ''}
                                        aria-current={index === 0 ? 'true' : 'false'}
                                        aria-label={`Slide ${index}`}>
                                    </button>
                                ))
                            }
                        </div>
                        <div className="carousel-inner">
                            {
                                reviews.map((review, index) => (
                                    <div
                                        className={`carousel-item h-auto d-flex gap-28 max-sm:gap-4 max-lg:gap-6 ${index === 0 ? 'active' : ''}`}
                                        key={index}>
                                        <div className='col-sm-7 max-sm:p-4 px-16'>
                                            <h1 className=' h1 mr-sm-20 theme-blue-color mb-10 pt-14 max-md:pt-10 max-md:mb-2'>{trans(review.heading)}</h1>
                                            <h2 className='h2 mb-10 max-md:mb-6 theme-dark-blue'>{trans(review.subHeading)}</h2>
                                            <div className='d-flex justify-center d-block d-sm-none'>
                                                <img src={review.image} className='rounded-full h-[100px] w-[100px]'>
                                                </img>
                                            </div>
                                            <div>
                                                <img src={quotes} className='mb-4 max-sm:mt-5 max-sm:w-16 inline'></img>
                                            </div>

                                            {
                                                Array.from({length: review.stars}).map((_, index) => (
                                                    <img className='inline' src={star} key={index}></img>
                                                ))
                                            }
                                            <p className='mt-4 h-20 max-xl:h-max max-2xl:h-max max-sm:h-[155px] text-sm md:text-xl'>{trans(review.description)}</p>

                                            <h6 className='h5 mb-5 max-sm:!mb-5 font-bold mt-3 theme-dark-blue'>{trans(review.name)}</h6>
                                            <div className={'flex rtl:flex-row-reverse rtl:justify-end gap-x-7'}>
                                                <button type="button" className='align-middle pb-14 max-sm:pb-8'
                                                        data-bs-target="#carouselExampleDark" data-bs-slide="prev">
                                                    <TfiArrowCircleLeft color='#3385D7' size={"40"}/>
                                                </button>

                                                <button type="button" className='align-middle pb-14 max-sm:pb-8'
                                                        data-bs-target="#carouselExampleDark" data-bs-slide="next">
                                                    <TfiArrowCircleRight color='#3385D7' size={"40"}/>
                                                </button>
                                            </div>
                                        </div>
                                        <div className='col-5 testiImg '>
                                            <img src={review.image}
                                                 className="d-block w-100 h-[712px] max-xl:h-[800px] object-cover"
                                                 alt="..."/>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>

            <section id="expSec" className=''>
                <h1 className='text-center h1 text-white pt-32 max-md:pt-12'>{trans('Patient Experiences')}</h1>
                <h1 className='text-center h2 text-white mb-24 max-md:mb-12 mt-4 '>{trans('Watch what our patient says about us')}</h1>
                <div className='container pb-36 max-md:pb-12'>

                    <div className='row justify-center gap-y-10 '>
                        <iframe
                            src="https://www.facebook.com/plugins/video.php?height=469&href=https%3A%2F%2Fwww.facebook.com%2Fdentistryperfectsmile%2Fvideos%2F590234879085678%2F&show_text=false&width=560&t=0"
                            clas width="560" height="469" style={{border: "none", overflow: "hidden"}} scrolling="no"
                            frameborder="0" className='vidIframe col-sm-6 md:h-[300px] lg:h-[300px] xl:h-[469px]'
                            allowFullScreen="true"
                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                            allowFullScreen="true"></iframe>

                        <iframe
                            src="https://www.facebook.com/plugins/video.php?height=469&href=https%3A%2F%2Fwww.facebook.com%2Fdentistryperfectsmile%2Fvideos%2F3144463749138938%2F&show_text=false&width=560&t=0"
                            width="560" height="469" style={{border: "none", overflow: "hidden"}} scrolling="no"
                            frameborder="0"
                            className='vidIframe col-sm-6 md:h-[300px] lg:h-[300px] xl:h-[469px]' allowFullScreen="true"
                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                            allowFullScreen="true"></iframe>


                    </div>
                </div>
            </section>

            <section id="transformSec" className=''>
                <h1 className='text-center h1 theme-blue-color  mb-24 max-md:mb-12 pt-32 max-md:pt-12'>{trans('Before and after results')}</h1>
                <div className='container pb-36 max-md:pb-12'>
                    {/* <span>Before</span>
          <span>After</span> */}
                    <div className='grid grid-cols-2 gap-y-20 justify-items-center max-xl:grid-cols-1 max-xl:gap-y-10'>

                        <ReactCompareSlider className='transform-img-mainDiv ' onlyHandleDraggable={true}
                                            style={{filter: "brightness(1) !important"}}
                                            itemOne={<ReactCompareSliderImage src={trans1B}
                                                                              className='transform-images transform-img-before '
                                                                              alt="Image one"/>}
                                            itemTwo={<ReactCompareSliderImage src={trans1A}
                                                                              className='transform-images transform-img-after '
                                                                              alt="Image two"/>}
                        />
                        <ReactCompareSlider className='transform-img-mainDiv ' onlyHandleDraggable={true}
                                            style={{filter: "brightness(1) !important"}}
                                            itemOne={<ReactCompareSliderImage src={trans2B}
                                                                              className='transform-images transform-img-before '
                                                                              alt="Image one"/>}
                                            itemTwo={<ReactCompareSliderImage src={trans2A}
                                                                              className='transform-images transform-img-after '
                                                                              alt="Image two"/>}
                        />
                        <ReactCompareSlider className='transform-img-mainDiv ' onlyHandleDraggable={true}
                                            style={{filter: "brightness(1) !important"}}
                                            itemOne={<ReactCompareSliderImage src={trans3B}
                                                                              className='transform-images transform-img-before '
                                                                              alt="Image one"/>}
                                            itemTwo={<ReactCompareSliderImage src={trans3A}
                                                                              className='transform-images transform-img-after '
                                                                              alt="Image two"/>}
                        />
                        <ReactCompareSlider className='transform-img-mainDiv ' onlyHandleDraggable={true}
                                            style={{filter: "brightness(1) !important"}}
                                            itemOne={<ReactCompareSliderImage src={trans4B}
                                                                              className='transform-images transform-img-before '
                                                                              alt="Image one"/>}
                                            itemTwo={<ReactCompareSliderImage src={trans4A}
                                                                              className='transform-images transform-img-after '
                                                                              alt="Image two"/>}
                        />
                        <ReactCompareSlider className='transform-img-mainDiv ' onlyHandleDraggable={true}
                                            style={{filter: "brightness(1) !important"}}
                                            itemOne={<ReactCompareSliderImage src={trans5B}
                                                                              className='transform-images transform-img-before '
                                                                              alt="Image one"/>}
                                            itemTwo={<ReactCompareSliderImage src={trans5A}
                                                                              className='transform-images transform-img-after '
                                                                              alt="Image two"/>}
                        />
                        <ReactCompareSlider className='transform-img-mainDiv ' onlyHandleDraggable={true}
                                            style={{filter: "brightness(1) !important"}}
                                            itemOne={<ReactCompareSliderImage src={trans6B}
                                                                              className='transform-images transform-img-before '
                                                                              alt="Image one"/>}
                                            itemTwo={<ReactCompareSliderImage src={trans6A}
                                                                              className='transform-images transform-img-after '
                                                                              alt="Image two"/>}
                        />
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Home